import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

interface SiteLayoutProps {
  children: ReactNode;
  overlayHeader?: boolean;
}

export default function SiteLayout({ children, overlayHeader = false }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader overlay={overlayHeader} />
      <main className={`flex-1 ${overlayHeader ? "" : "pt-[68px] md:pt-[76px]"}`}>
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}